module.exports = __webpack_public_path__ + "media/images/countdown__background-88f8efb4684dab12abea475b86984c8c.jpg";